// extracted by mini-css-extract-plugin
export default {"label":"label__sn_iz","tooltipIcon":"tooltipIcon__vDmUs","switch":"switch__WHIWN"};